import { Component, Input } from '@angular/core';

@Component({
    selector: 'bot-processes',
    templateUrl: 'bot-processes.component.html',
    styleUrls: ['bot-processes.component.scss']
})
export class BotProcessesComponent {
    @Input() title;
    @Input() botProcesses;
}